import { render, staticRenderFns } from "./TrueFalse.vue?vue&type=template&id=998ed9e8&scoped=true"
import script from "./TrueFalse.vue?vue&type=script&lang=ts"
export * from "./TrueFalse.vue?vue&type=script&lang=ts"
import style0 from "./TrueFalse.vue?vue&type=style&index=0&id=998ed9e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998ed9e8",
  null
  
)

export default component.exports